import { Box, useMediaQuery } from "@mui/material";
import { USER_PROFILE_DATA } from "../../../api/url";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { JobCardServiceType, ServiceAdvisorListApi, VehicleListApi } from "../../jobCard/services/JobCardApiCall";
import { JcKey } from "../../jobCard/services/jcEntity";
import dayjs from "dayjs";
export var JobCardInvoiceReturnFilter = function (props) {
    var _getLocalStorageItem, _userData$data, _userData$data2, _userData$data3, _serviceAdvisors$;
    var onClose = props.onClose, state = props.state;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var BranchData = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var crud = useAppSelector(function (state) { return state.crud; });
    var Branch = [{
            OrganizationName: BranchData === null || BranchData === void 0 ? void 0 : BranchData.OrganizationName,
            OrganizationId: BranchData === null || BranchData === void 0 ? void 0 : BranchData.OrganizationId,
            BranchCode: BranchData.BranchCode,
            ParentOrganizationId: BranchData.ParentOrganizationId
        }];
    var serviceAdvisors = [{
            advisorName: "".concat(userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.GivenName, " ").concat(userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.FamilyName),
            IdentityId: userData === null || userData === void 0 || (_userData$data3 = userData.data) === null || _userData$data3 === void 0 ? void 0 : _userData$data3.IdentityId
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: isMobile ? '16px 0px' : 0,
            columnSize: 12,
            mt: isMobile ? 0 : 6,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Filter',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "currentColor",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    color: 'secondary',
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            spacing: 0,
            columnSize: 12,
            gap: 2,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    label: '',
                    placeholder: 'Selected saved filter',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'BranchId',
                    label: 'Branch',
                    displayExpr: "OrganizationName",
                    valueExpr: "OrganizationId",
                    options: Branch || [],
                    // getListData: branchList,
                    // apiRequest: { ParentOrganizationId: BranchData?.ParentOrganizationId, OrganizationTypeGroup: 1 },
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'serviceType',
                    label: 'Service type',
                    displayExpr: "Name",
                    valueExpr: "id",
                    getListData: JobCardServiceType,
                    value: null,
                    apiRequest: {
                        ModuleEntityId: "JobCard",
                        OrganizationId: userOrganizationID
                    },
                    apiKey: JcKey.JcServiceType,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Vehicle',
                    label: 'Vehicle',
                    getListData: VehicleListApi,
                    apiRequest: {
                        SystemName: "Product",
                        OrganizationId: userOrganizationID
                    },
                    value: null,
                    getOptionLabel: function (option) {
                        var _option$Name, _option$SkuCode;
                        return option !== null && option !== void 0 && option.Name && option !== null && option !== void 0 && option.SkuCode ? "".concat((_option$Name = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name !== void 0 ? _option$Name : '', " (").concat((_option$SkuCode = option === null || option === void 0 ? void 0 : option.SkuCode) !== null && _option$SkuCode !== void 0 ? _option$SkuCode : '', ")") : option === null || option === void 0 ? void 0 : option.Name;
                    },
                    displayExpr: "Name",
                    valueExpr: "id",
                    columnSize: 12
                }, (state === null || state === void 0 ? void 0 : state.IdentityId) === "all" ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'serviceAdviser',
                    label: 'Service adviser',
                    getListData: ServiceAdvisorListApi,
                    apiKey: JcKey.ServiceAdvisorList,
                    apiRequest: {
                        BranchId: userOrganizationID
                    },
                    valueExpr: "IdentityId",
                    displayExpr: "FirstName",
                    getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.FirstName, " ").concat(option === null || option === void 0 ? void 0 : option.FamilyName); },
                    value: null,
                    columnSize: 12,
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: FormItemTypes.SearchSelect,
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.BranchId)
                        };
                    }
                } : {
                    type: FormItemTypes.TextInput,
                    name: 'serviceAdviser',
                    label: 'Service Adviser',
                    disabled: true,
                    value: serviceAdvisors === null || serviceAdvisors === void 0 || (_serviceAdvisors$ = serviceAdvisors[0]) === null || _serviceAdvisors$ === void 0 ? void 0 : _serviceAdvisors$.advisorName,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'JcDate',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'FromDate',
                            label: 'Date range',
                            placeholder: "From date",
                            columnSize: 12,
                            timezone: 'system',
                            setFormState: function (formValues, currValue, field) {
                                if (!currValue)
                                    return {
                                        ToDate: null
                                    };
                            }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'ToDate',
                            columnSize: 12,
                            timezone: 'system',
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    minDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate),
                                    disabled: !(formValues !== null && formValues !== void 0 && formValues.FromDate),
                                    required: !(formValues !== null && formValues !== void 0 && formValues.FromDate),
                                    placeholder: formValues !== null && formValues !== void 0 && formValues.FromDate ? "To date *" : "To date"
                                };
                            }
                        }],
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            width: {
                xs: '350px'
            },
            justifyContent: 'space-between',
            position: 'fixed',
            bottom: 0,
            right: 0,
            spacing: 0,
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Save filter',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: 'Reset filters',
                    color: 'secondary',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Apply',
                    columnSize: 0
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        padding: 3
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData
    })));
};
